interface RightArrowInTabsMenuProps {
    color: string;
    onClick: () => void;
    isVisibleOnHover?: boolean;
    additionalClassName?: string;
    svgAdditionalClassName?: string;
    minHeight?: string;
    isArrowHidden?: boolean;
}

export const RightArrowInTabsMenu = ({
    color, onClick,
    isVisibleOnHover = true,
    additionalClassName,
    svgAdditionalClassName,
    minHeight = '',
    isArrowHidden = false
}: RightArrowInTabsMenuProps) => {
    return (
        <>
            {isArrowHidden ? null : (
                <div className={`flex justify-center items-center min-w-[16px] cursor-pointer 
                ${isVisibleOnHover ? 'opacity-100' : 'opacity-0'} 
                ${additionalClassName}
                ${minHeight}`}
                    onClick={onClick}
                >
                    <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={`${svgAdditionalClassName}`}>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M0.849226 0.240761C1.26855 -0.11866 1.89985 -0.0700988 2.25927 0.349226L8.25926 7.34921C8.58025 7.7237 8.58025 8.2763 8.25926 8.65079L2.25927 15.6508C1.89985 16.0701 1.26855 16.1187 0.849226 15.7592C0.429901 15.3998 0.38134 14.7685 0.740761 14.3492L6.18293 8L0.740761 1.65081C0.38134 1.23148 0.429901 0.600182 0.849226 0.240761Z"
                            fill={color}
                        />
                    </svg>
                </div>
            )}
        </>
    )
}
